import React from 'react';
import '../App.css'; // or a separate CSS file

export default function PageSection({ id, children }) {
  return (
    <div className="section-wrapper" id={id}>
      {children}
      <div className="section-bottom-shadow" />
    </div>
  );
}
